import script from "./UpgradeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeModal.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeModal.vue?vue&type=style&index=0&id=5f305a3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f305a3c"]])

export default __exports__